/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadFilter
 */
export interface ReadFilter {
    /**
     * The name of the field to filter on.
     * @type {string}
     * @memberof ReadFilter
     */
    fieldName: string;
    /**
     * The comparison operator.
     * @type {string}
     * @memberof ReadFilter
     */
    operator: ReadFilterOperatorEnum;
    /**
     * The value to filter on. Allowed types are string, boolean, and number.
     * @type {any}
     * @memberof ReadFilter
     */
    value?: any | null;
}


/**
 * @export
 */
export const ReadFilterOperatorEnum = {
    Eq: 'eq'
} as const;
export type ReadFilterOperatorEnum = typeof ReadFilterOperatorEnum[keyof typeof ReadFilterOperatorEnum];


/**
 * Check if a given object implements the ReadFilter interface.
 */
export function instanceOfReadFilter(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fieldName" in value;
    isInstance = isInstance && "operator" in value;

    return isInstance;
}

export function ReadFilterFromJSON(json: any): ReadFilter {
    return ReadFilterFromJSONTyped(json, false);
}

export function ReadFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldName': json['fieldName'],
        'operator': json['operator'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function ReadFilterToJSON(value?: ReadFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldName': value.fieldName,
        'operator': value.operator,
        'value': value.value,
    };
}

